import React, { useEffect } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';
import { createPortal } from 'react-dom';
import { providerId, openPortalTag } from '../popupProvider/PopupProvider';
import { PopupWrapperProps, PopupPortalProps, PopupProps } from './models';
import * as styles from './styles';
import { CloseButton } from '../closeButton/CloseButton';
import { getPurchasePopupDataTestId } from './helpers';

const PopupPortal = ({ children }: PopupPortalProps) => {
  const popupProviderElement = document.getElementById(providerId);

  useEffect(() => {
    const uniqueClass = ` ${openPortalTag} ${new Date().getTime()}`;
    popupProviderElement.className += uniqueClass;

    return () => {
      popupProviderElement.className = popupProviderElement.className.replace(uniqueClass, '');
    };
  }, []);

  return createPortal(children, popupProviderElement);
};

// TODO: Append tests
export const PopupWrapper = styled(({ children, className, dataTestId }: PopupWrapperProps) => {
  return (
    <PopupPortal>
      <div
        {...{
          className: classNames(className, 'popup-wrapper'),
          'data-testid': dataTestId,
        }}
      >
        {children}
      </div>
    </PopupPortal>
  );
})`
  ${styles.PopupWrapper}
`;

export const Popup = styled(({ children, className, onClose, dataTestId, disableCloseButton }: PopupProps) => (
  <div {...{ className, 'data-testid': dataTestId && getPurchasePopupDataTestId(dataTestId) }}>
    {disableCloseButton && <CloseButton onClick={onClose} size={24} />}
    {children}
  </div>
))`
  ${styles.Popup}
`;
